function isoDate(value) {
  const text = String(value || "").trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : "";
}

export function canCompleteRebalance(recommendation, currentDate) {
  const schedule = recommendation?.rebalance_schedule || {};
  const scheduledDate = isoDate(schedule.scheduled_rebalance_date);
  const today = isoDate(currentDate);
  const workflowStatus = String(
    recommendation?.workflow?.status || "",
  ).toLowerCase();
  const scheduleStatus = String(schedule.status || "").toLowerCase();
  return Boolean(
    scheduledDate
      && today
      && scheduledDate <= today
      && workflowStatus !== "complete"
      && !["draft", "preview"].includes(scheduleStatus),
  );
}

export function rebalanceScheduleStatus(
  schedule,
  currentDate,
  workflowStatus = "",
) {
  const date = isoDate(schedule?.next_rebalance_date);
  if (!date) {
    return null;
  }
  const status = String(schedule?.status || "scheduled").toLowerCase();
  if (status === "draft") {
    return { date, label: "Draft rebalance", tone: "draft" };
  }
  if (status === "completed") {
    return { date, label: "Rebalance completed", tone: "completed" };
  }
  if (String(workflowStatus).toLowerCase() === "complete") {
    return { date, label: "Rebalance completed", tone: "completed" };
  }
  if (status !== "preview") {
    const scheduledDate = isoDate(schedule?.scheduled_rebalance_date);
    const today = isoDate(currentDate);
    if (scheduledDate && today && scheduledDate < today) {
      return { date, label: "Rebalance overdue", tone: "overdue" };
    }
    if (scheduledDate && today && scheduledDate === today) {
      return { date, label: "Rebalance due", tone: "due" };
    }
  }
  if (status === "overdue") {
    return { date, label: "Rebalance overdue", tone: "overdue" };
  }
  if (status === "due") {
    return { date, label: "Rebalance due", tone: "due" };
  }
  return { date, label: "Next rebalance", tone: "scheduled" };
}
